/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { TransactionDetailViewModel } from './TransactionDetailViewModel';
import {
    TransactionDetailViewModelFromJSON,
    TransactionDetailViewModelFromJSONTyped,
    TransactionDetailViewModelToJSON,
} from './TransactionDetailViewModel';

/**
 * 
 * @export
 * @interface ResultOfTransactionDetailViewModel
 */
export interface ResultOfTransactionDetailViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfTransactionDetailViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTransactionDetailViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfTransactionDetailViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTransactionDetailViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTransactionDetailViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfTransactionDetailViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfTransactionDetailViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {TransactionDetailViewModel}
     * @memberof ResultOfTransactionDetailViewModel
     */
    data?: TransactionDetailViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfTransactionDetailViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfTransactionDetailViewModel interface.
 */
export function instanceOfResultOfTransactionDetailViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfTransactionDetailViewModelFromJSON(json: any): ResultOfTransactionDetailViewModel {
    return ResultOfTransactionDetailViewModelFromJSONTyped(json, false);
}

export function ResultOfTransactionDetailViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfTransactionDetailViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : TransactionDetailViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfTransactionDetailViewModelToJSON(value?: ResultOfTransactionDetailViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': TransactionDetailViewModelToJSON(value.data),
        'Count': value.count,
    };
}

